import { DateColumnHeader } from "src/components/timeZone/dateColumnHeader";
import { FormattedDateDisplay } from "src/components/timeZone/formattedDateDisplay";
import { FORMAT } from "src/dataTypes/dateFormats";
import { numberComparator } from "src/utils/comparator";

import {
  agGridResourcesNumberDefault,
  BaseColumnConfig,
  Config
} from "./baseColumnConfig";

export class TimeColumn extends BaseColumnConfig<Date> {
  constructor(cfg: Config) {
    const enhancedConfig: Config = {
      ...cfg,
      header:
        cfg.header ||
        (() => {
          return <DateColumnHeader label={cfg.label} />;
        })
    };
    super(enhancedConfig, agGridResourcesNumberDefault);
  }

  identity(value?: Date) {
    return value?.getTime().toString(); // simple id generation from timestamp
  }

  compare(a: Date | undefined, b: Date | undefined): number {
    return numberComparator(a?.getTime(), b?.getTime());
  }

  toString(val: Date | undefined): string {
    return val?.toLocaleTimeString() || "";
  }

  render(val: Date | undefined): JSX.Element {
    return (
      <FormattedDateDisplay
        value={val}
        format={FORMAT.TIME_LONG}
        showTimeZone={false}
      />
    );
  }
}
